import type { Address } from '../../address/models/Address'

export enum CompanyAddressType {
  Default = 'default',
  Charge = 'charge'
}

export interface CompanyAddress {
  address: Address
  type: CompanyAddressType
}
